import { mutationTypes } from '@/core/constants'
import { FiltroUtils } from '@/core/utils'

export default {
	[mutationTypes.ATA.DOCUMENTOS_ATA.SET_FILTRO_LISTAGEM](state, filtro) {
		state.filtro = filtro
	},

	[mutationTypes.ATA.DOCUMENTOS_ATA.SET_PAGINACAO_LISTAGEM](state, paginacao) {
		state.paginacao = paginacao
	},

	[mutationTypes.ATA.DOCUMENTOS_ATA.LIMPAR_FILTRO_LISTAGEM](state) {
		FiltroUtils.limparFiltroAvancado(state.filtro)
	},

	[mutationTypes.ATA.DOCUMENTOS_ATA.RESETAR_PAGINA_LISTAGEM](state) {
		state.paginacao.page = 1
	},

	[mutationTypes.ATA.DOCUMENTOS_ATA.CHECKBOX.SET_IS_SELECIONOU_TODOS_ITENS](state) {
		state.isSelecionouTodosItensDaListaDeDocumentosAta = true
	},

	[mutationTypes.ATA.DOCUMENTOS_ATA.CHECKBOX.DESFAZER_SELECAO_ITENS_LISTAGEM](state) {
		state.isSelecionouTodosItensDaListaDeDocumentosAta = false
		state.documentosSelecionados = []
	},

	[mutationTypes.ATA.DOCUMENTOS_ATA.CHECKBOX.DOCUMENTOS_SELECIONADOS](state, itens) {
		state.documentosSelecionados = itens
	},

	[mutationTypes.ATA.DOCUMENTOS_ATA.SET_EXIBIR_SINCRONIZAR_AREA_PUBLICA](state, itens) {
		let itensPermitemEnviar = 0
		let itensPermitemCancelar = 0

		itens.forEach((item) => (item.isDocPublico ? itensPermitemCancelar++ : itensPermitemEnviar++))

		state.exibirSincronizarAreaPublica.desabilitarEnviar = itensPermitemEnviar === 0 && itensPermitemCancelar > 0
		state.exibirSincronizarAreaPublica.desabilitarCancelar = itensPermitemCancelar === 0 && itensPermitemEnviar > 0
	},

	[mutationTypes.ATA.DOCUMENTOS_ATA.ATUALIZAR_LISTAGEM](state) {
		state.atualiza++
	},

	async [mutationTypes.ATA.DOCUMENTOS_ATA.ATUALIZAR_LISTAGEM_COM_TIMEOUT](state, ms) {
		let sleep = new Promise((resolve) => setTimeout(resolve, ms))

		await sleep

		state.atualiza++
	},
}
